module.exports = __webpack_public_path__ + "brandon_blk-webfont.84c5196be52e80f6274f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_blk-webfont.woff
// module id = 935
// module chunks = 7